export const CREATE_TIME_NOTE_APPOINTMENT = "CREATE_TIME_NOTE_APPOINTMENT";
export const UPDATE_TIME_NOTE_APPOINTMENT = "UPDATE_TIME_NOTE_APPOINTMENT";

export const CREATE_TIME_NOTE_APPOINTMENT_SUCCESS = "CREATE_TIME_NOTE_APPOINTMENT_SUCCESS";
export const UPDATE_TIME_NOTE_APPOINTMENT_SUCCESS = "UPDATE_TIME_NOTE_APPOINTMENT_SUCCESS";
